<template>
  <div class="header-subnav color-white" lpos="navi_flyout" inert>
    <div class="container contentWidth">
      <div class="row">
        <div class="col-xl-6">
          <div class="row">
            <div class="col-xl-12">
              <ul>
                <li>
                  <a
                    :href="links[0].href"
                    :title="links[0].title"
                    itemprop="url"
                    :class="{
                      submenuItem: true,
                      'preventLink hideOnTouch': links[0].href === '#',
                    }"
                    @click="checkPreventLink"
                  >
                    <span itemprop="name" class="dim">{{ links[0].text }}</span>
                  </a>
                </li>
                <li v-for="(link, index) in links.slice(1)" :key="link.title">
                  <a
                    :href="link.href"
                    :title="link.title"
                    itemprop="url"
                    class="submenuItem"
                    :class="{ last: index === links.length - 2 }"
                  >
                    <span itemprop="name">{{ link.text }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type Link } from 'ewi-ui-helpers/types';
export interface SubnavProps {
  links: Link[];
  title: string;
}

defineProps<SubnavProps>();

const checkPreventLink = (event: MouseEvent) => {
  const linkElement = event.target as HTMLElement;
  const link = linkElement.getAttribute('href');
  if (link === '#') {
    event.preventDefault();
    return false;
  }
};
</script>
